/* Tuxedo Tiger auction UI: shared clock/deal picker + sticky bar, auction card, past auctions TEST mode, nudge pop-up.
   Deals come from <script data-tt-auction-json> (snippet tt-auction-data). Day rolls over at midnight America/Denver (MT).
   ?auction_test=<ISO> fakes "now" (preview/unpublished themes + theme editor only, unless a section allows it).
   ?auction_test_past=1 adds TEST past-auction cards client-side (never saved). ?auction_open=1|0 forces bar state. */
(function () {
  if (window.TTAuction) { window.TTAuction.boot(); return; }
  var TZ = 'America/Denver';
  function tzParts(ts) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var o = {}; f.formatToParts(new Date(ts)).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second };
  }
  function tzOffset(ts) { var p = tzParts(ts); return Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - Math.floor(ts / 1000) * 1000; }
  function nextMidnight(ts) { var p = tzParts(ts); var wall = Date.UTC(p.y, p.m - 1, p.d + 1, 0, 0, 0); var g = wall - tzOffset(ts); return wall - tzOffset(g); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms, short) { if (ms < 0) ms = 0; var s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor(s / 60) % 60;
    return short ? pad(h) + ':' + pad(m) : pad(h) + ':' + pad(m) + ':' + pad(s % 60); }

  var qp = new URLSearchParams(window.location.search);
  var role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
  var allowAttr = !!document.querySelector('[data-tt-allow-test="true"]');
  var allow = allowAttr || (role && role !== 'main') || !!(window.Shopify && window.Shopify.designMode);
  var skew = 0, test = false;
  if (qp.get('auction_test') && allow) { var t = Date.parse(qp.get('auction_test')); if (isFinite(t)) { skew = t - Date.now(); test = true; } }
  var testPast = allow && qp.get('auction_test_past') === '1';
  function now() { return Date.now() + skew; }

  var deals = null;
  function getDeals() {
    if (deals) return deals;
    deals = [];
    var el = document.querySelector('[data-tt-auction-json]');
    try { deals = JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { deals = []; }
    return deals;
  }
  function pick() {
    var n = now(), ds = getDeals();
    for (var i = 0; i < ds.length; i++) { var d = ds[i]; if (n >= d.s && n < d.e && (test ? (d.available || d.src > 0) : (d.url && d.available))) return d; }
    return null;
  }
  function left(d) { var n = now(), l = nextMidnight(n) - n; if (d && d.e - n < l) l = d.e - n; return l; }
  function img(d, w) { return d.img ? d.img + (d.img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  var subs = [], current, timer;
  function tick() {
    var d = pick();
    var changed = d !== current; current = d;
    for (var i = 0; i < subs.length; i++) { try { subs[i](d, changed); } catch (e) { if (window.console) console.error(e); } }
  }
  function sub(fn) { subs.push(fn); fn(current, true); }

  function fill(root, d, opts) {
    function $(s) { return root.querySelectorAll(s); }
    function set(s, v) { $(s).forEach(function (e) { e.textContent = v; }); }
    function show(s, on) { $(s).forEach(function (e) { e.hidden = !on; }); }
    $('[data-tt-img]').forEach(function (e) { var w = +e.getAttribute('data-tt-img') || 200; var src = img(d, w); if (e.getAttribute('src') !== src) e.src = src; e.alt = d.title; });
    set('[data-tt-title]', d.title);
    set('[data-tt-variant]', d.variant || '');
    show('[data-tt-variant]', !!d.variant);
    set('[data-tt-deal]', d.deal);
    set('[data-tt-retail]', d.retail); show('[data-tt-retail]', !!d.retail && d.retail !== d.deal);
    set('[data-tt-save]', d.pct ? d.pct + '% off' : ''); show('[data-tt-save]', !!d.pct);
    set('[data-tt-limited]', d.limited ? 'Only limited to ' + d.limited : ''); show('[data-tt-limited]', !!d.limited);
    set('[data-tt-retail-line]', d.retail ? 'Retail is ' + d.retail : ''); show('[data-tt-retail-line]', !!d.retail);
    set('[data-tt-hype]', d.hype || ''); show('[data-tt-hype]', !!d.hype);
    show('[data-tt-testflag]', test);
    $('[data-tt-link]').forEach(function (a) {
      var custom = a.getAttribute('data-tt-link');
      var label = a.getAttribute('data-label') || a.textContent;
      a.setAttribute('data-label', label);
      var href = custom || d.url;
      if (href && (custom || d.available)) { a.href = href; a.textContent = label; a.classList.remove('is-disabled'); a.removeAttribute('aria-disabled'); }
      else { a.removeAttribute('href'); a.classList.add('is-disabled'); a.setAttribute('aria-disabled', 'true'); a.textContent = 'Preview only'; }
    });
  }
  function clocks(root, d) { var t = fmt(left(d)); root.querySelectorAll('[data-tt-clock]').forEach(function (e) { e.textContent = t; }); }

  /* ---------- sticky bar ---------- */
  function initBar(el) {
    if (el._tt) return; el._tt = 1;
    var key = 'ttBarOpen', saved = null; try { saved = sessionStorage.getItem(key); } catch (e) {}
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    var open = saved !== null ? saved === '1' : (desktop ? el.getAttribute('data-open-desktop') === 'true' : el.getAttribute('data-open-mobile') === 'true');
    var f = qp.get('auction_open'); if (f === '1' || f === '0') open = f === '1';
    var root = document.documentElement;
    function measure() {
      var h = (el.hidden || el.classList.contains('is-tucked')) ? 0 : el.offsetHeight;
      root.style.setProperty('--tt-bar-h', h + 'px');
      document.body.classList.toggle('tt-bar-on', h > 0);
      document.body.classList.toggle('tt-bar-open', h > 0 && el.classList.contains('is-open'));
    }
    function setOpen(o, store) {
      open = o; el.classList.toggle('is-open', o);
      el.querySelectorAll('[data-tt-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', o ? 'true' : 'false'); b.setAttribute('aria-label', o ? 'Collapse auction bar' : 'Expand auction bar'); });
      if (store) { try { sessionStorage.setItem(key, o ? '1' : '0'); } catch (e) {} }
      measure();
    }
    el.querySelectorAll('[data-tt-toggle]').forEach(function (b) { b.addEventListener('click', function () { setOpen(!open, true); }); });
    setOpen(open, false);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(el);
    window.addEventListener('resize', measure);
    // slide away while a drawer / modal is open (cart drawer, menu, search)
    if (window.MutationObserver) new MutationObserver(function () {
      el.classList.toggle('is-tucked', document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-tablet') || document.body.classList.contains('overflow-hidden-mobile'));
      measure();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    sub(function (d, changed) {
      if (!d) { if (!el.hidden) { el.hidden = true; measure(); } return; }
      if (changed) { fill(el, d); el.hidden = false; measure(); }
      clocks(el, d);
    });
  }

  /* ---------- homepage / auction page card ---------- */
  function initCard(el) {
    if (el._tt) return; el._tt = 1;
    sub(function (d, changed) {
      if (!d) { el.hidden = true; return; }
      if (changed) { fill(el, d); el.hidden = false; }
      clocks(el, d);
    });
  }

  /* ---------- past auctions (TEST simulation only) ---------- */
  function initPast(el) {
    if (el._tt) return; el._tt = 1;
    if (!testPast) return;
    var grid = el.querySelector('[data-tt-past-grid]'), empty = el.querySelector('[data-tt-past-empty]');
    var ds = getDeals().slice(0, 4);
    if (!ds.length || !grid) return;
    var note = document.createElement('p'); note.className = 'tt-past__testnote'; note.textContent = 'TEST: sample cards for preview only. Not real results, not saved.';
    grid.parentNode.insertBefore(note, grid);
    ds.forEach(function (d, i) {
      var li = document.createElement('li'); li.className = 'tt-past__item';
      var ended = new Date(d.s - i * 86400000);
      li.innerHTML = '<div class="tt-past__card"><div class="tt-past__media"><img loading="lazy" alt=""><span class="tt-past__sold">TEST</span></div><div class="tt-past__info">' +
        '<p class="tt-past__name"></p><p class="tt-past__variant"></p><p class="tt-past__prices"><span class="tt-past__won"></span><s class="tt-past__reg"></s></p>' +
        '<p class="tt-past__hype" data-r></p><p class="tt-past__hype" data-l></p><p class="tt-past__date"></p></div></div>';
      li.querySelector('img').src = img(d, 400); li.querySelector('img').alt = d.title;
      li.querySelector('.tt-past__name').textContent = d.title;
      li.querySelector('.tt-past__variant').textContent = d.variant || '';
      li.querySelector('.tt-past__won').textContent = 'Won for ' + d.deal + ' (TEST)';
      li.querySelector('.tt-past__reg').textContent = d.retail;
      li.querySelector('[data-r]').textContent = d.retail ? 'Retail is ' + d.retail : '';
      li.querySelector('[data-l]').textContent = d.limited ? 'Only limited to ' + d.limited : '';
      li.querySelector('.tt-past__date').textContent = 'Ended ' + ended.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: TZ });
      grid.appendChild(li);
    });
    if (empty) empty.hidden = true;
  }

  /* ---------- nudge pop-up ---------- */
  function initNudge(el) {
    if (el._tt) return; el._tt = 1;
    var KEY = 'ttNudgeDismissed';
    try { if (sessionStorage.getItem(KEY) === '1' && qp.get('auction_nudge') !== '1') return; } catch (e) {}
    var link = el.querySelector('[data-tt-nudge-link]');
    var href = el.getAttribute('data-href') || '/pages/auction';
    link.href = href;
    var path = window.location.pathname.replace(/\/$/, '');
    var target; try { target = new URL(href, window.location.origin).pathname.replace(/\/$/, ''); } catch (e) { target = href; }
    if (path === target || /\/pages\/auction$/.test(path) || /\/cart$/.test(path)) return;
    var tpl = el.getAttribute('data-text') || '🔨 Auction live — ends in {time}';
    var txt = el.querySelector('[data-tt-nudge-txt]');
    var delay = (+el.getAttribute('data-delay') || 8) * 1000;
    if (qp.get('auction_nudge') === '1') delay = 500;
    var ready = false, shown = false, active = null;
    setTimeout(function () { ready = true; render(); }, delay);
    function render() {
      if (!ready || !active) { if (shown) { el.classList.remove('is-in'); } return; }
      if (active && active.url && path === active.url.replace(/\/$/, '')) return; // on the deal product itself
      var t = fmt(left(active), true);
      var parts = tpl.split('{time}');
      txt.textContent = '';
      txt.appendChild(document.createTextNode(parts[0]));
      if (parts.length > 1) { var s = document.createElement('span'); s.className = 'tt-nudge__time'; s.textContent = t; txt.appendChild(s); txt.appendChild(document.createTextNode(parts.slice(1).join(''))); }
      if (!shown) { shown = true; el.hidden = false; requestAnimationFrame(function () { el.classList.add('is-in'); }); }
    }
    el.querySelector('[data-tt-nudge-x]').addEventListener('click', function () {
      el.classList.remove('is-in'); setTimeout(function () { el.hidden = true; }, 300);
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      ready = false;
    });
    sub(function (d) { active = d; if (!d && shown) { el.classList.remove('is-in'); el.hidden = true; shown = false; } render(); });
  }

  /* Shopify Inbox chat lives in an open shadow root: stack its button above the Rewards launcher, clear of the bar */
  function placeChat() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return;
    var css = '.activator-nudge--right{right:var(--tt-pill-edge,16px)!important;bottom:calc(var(--tt-bar-h,0px) + var(--tt-pill-gap,12px) + var(--tt-rewards-h,60px) * var(--tt-rewards-scale,1) + var(--tt-pill-gap,12px))!important;transition:bottom .25s ease}' +
      '.activator-nudge--left{left:var(--tt-pill-edge,16px)!important}';
    (function walk(r) {
      if (!r.querySelector('style[data-tt-pills]')) { var st = document.createElement('style'); st.setAttribute('data-tt-pills', ''); st.textContent = css; r.appendChild(st); }
      r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) walk(e.shadowRoot); });
    })(host.shadowRoot);
  }
  // the chat widget renders (and re-renders) its button asynchronously into nested shadow roots: keep placing it
  (function chatLoop(n) { placeChat(); if (n < 90) setTimeout(function () { chatLoop(n + 1); }, 1000); })(0);

  function boot() {
    deals = null;
    document.querySelectorAll('[data-tt-bar]').forEach(initBar);
    document.querySelectorAll('[data-tt-auc]').forEach(initCard);
    document.querySelectorAll('[data-tt-past]').forEach(initPast);
    document.querySelectorAll('[data-tt-nudge]').forEach(initNudge);
    current = undefined; tick();
  }
  window.TTAuction = { boot: boot, now: now, pick: pick, test: test };
  function start() { boot(); if (!timer) timer = setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', boot);
})();
